import {useTranslations} from 'next-intl';
import Faq from '@/content/faq';
import {SectionPadding} from '@/section';
import {P} from '@/typography';

type FaqItem = {
  question: string;
  answer: string;
};

const FaqSection = () => {
  const t = useTranslations('industryTechnology.faq');
  const items = t.raw('items') as FaqItem[];

  const questions = items.map(item => ({
    question: item.question,
    answer: <P>{item.answer}</P>
  }));

  return (
    <SectionPadding>
      <Faq title={t('title')} questions={questions} variant="accordion" isSafe arrow />
    </SectionPadding>
  );
};

export default FaqSection;
